<template>
    <form-row title="Financing Contingency" section_id="financing-contingency">
        <div>
            <div class="-mt-2">
                <input-radio-boolean
                    label="Cash Purchase?"
                    name="is_cash_purchase"
                    v-model="is_cash_purchase"
                    true="Yes"
                    false="No"
                    :read_only="read_only"
                />
            </div>

            <div v-show="! is_cash_purchase" class="flex flex-col sm:flex-row">
                <div class="mt-4">
                    <input-date
                        label="Date"
                        name="mortgage_contingency_due_date"
                        v-model="mortgage_contingency_due_date"
                        @entered="dateEntered"
                        :read_only="read_only"
                    />
                </div>

                <div class="w-24 sm:pl-6 mt-4">
                    <input-text
                        label="Period"
                        name="mortgage_contingency_period"
                        v-model="mortgage_contingency_period"
                        placeholder="Days"
                        :read_only="read_only"
                    />
                </div>
            </div>
        </div>
    </form-row>
</template>

<script>
import DateFunctions from '../../../mixins/date-functions.js';

export default {
    mixins: [
        DateFunctions,
    ],

    props: {
        mortgage: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            mortgage_contingency_due_date: this.mortgage.mortgage_contingency_due_date,
            mortgage_contingency_period: this.mortgage.mortgage_contingency_period,
            is_cash_purchase: this.mortgage.is_cash_purchase,
        }
    },

    computed: {
        contract_acceptance_date() {
            return store.state.contract_acceptance_date;
        },
        mortgage_contingency_due_date_from_period() {
            if (! this.contract_acceptance_date) {
                return;
            }

            if (this.isValidDate(this.contract_acceptance_date) && this.mortgage_contingency_period) {
                return dayjs(this.contract_acceptance_date.slice(0, 10))
                    .add({ day: this.mortgage_contingency_period })
                    .format('YYYY-MM-DD');
            }
        },
    },

    methods: {
        dateEntered() {
            this.mortgage_contingency_period = null;
        },
    },

    watch: {
        mortgage_contingency_due_date_from_period(val) {
            if (val) {
                this.mortgage_contingency_due_date = val;
            }
        },
        is_cash_purchase(val) {
            if (val) {
                this.mortgage_contingency_due_date = null;
                this.mortgage_contingency_period = null;
            }
        },
    },
}
</script>
